export const getEnv = (env: string) => {
  if (env === 'development') return 'DEV';
  if (env === 'staging') return 'STAGING';
  if (env === 'production') return 'PROD';
  if (env === 'dev') return 'DEV';
  return 'ukjent';
};
